module.exports = __webpack_public_path__ + "static/media/aboutImg0.b078e75f.webp";